import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/games/$id")({
	component: GameLayout,
})

function GameLayout() {
	return <Outlet />
}
